export default {
    'rects': [
        {
            'width': 200,
            'height': 150,
            'top': 10,
            'left': 10,
            'draggable': true,
            'resizable': true,
            'minw': 10,
            'minh': 10,
            'axis': 'both',
            'parentLim': true,
            'snapToGrid': false,
            'aspectRatio': false,
            'zIndex': 1,
            'color': '#EF9A9A',
            'active': false
        },
        {
            'width': 200,
            'height': 150,
            'top': 170,
            'left': 220,
            'draggable': true,
            'resizable': true,
            'minw': 10,
            'minh': 10,
            'axis': 'both',
            'parentLim': true,
            'snapToGrid': false,
            'aspectRatio': false,
            'zIndex': 1,
            'color': '#E6C27A',
            'active': false,
            'class': 'box-shaddow'
        },
        {
            'width': 200,
            'height': 150,
            'top': 10,
            'left': 220,
            'draggable': true,
            'resizable': true,
            'minw': 10,
            'minh': 10,
            'axis': 'both',
            'parentLim': true,
            'snapToGrid': false,
            'aspectRatio': false,
            'zIndex': 2,
            'color': '#AED581',
            'active': false
        },
        {
            'width': 200,
            'height': 150,
            'top': 170,
            'left': 10,
            'draggable': true,
            'resizable': true,
            'minw': 10,
            'minh': 10,
            'axis': 'both',
            'parentLim': true,
            'snapToGrid': false,
            'aspectRatio': false,
            'zIndex': 3,
            'color': '#81D4FA',
            'active': false
        }
    ]
};
